"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _theme = require("@zip/theme");

var _react = require("@emotion/react");

var _lottie_light = _interopRequireDefault(require("lottie-web/build/player/lottie_light"));

var _propTypes = require("prop-types");

var _react2 = require("react");

var _animationData = _interopRequireDefault(require("./animationData"));

var _animationData2 = _interopRequireDefault(require("./legacy/animationData"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LegacySpinner = function LegacySpinner(_ref) {
  var height = _ref.height,
      width = _ref.width,
      props = _objectWithoutProperties(_ref, ["height", "width"]);

  var myRef = (0, _react2.useRef)(null);
  (0, _react2.useEffect)(function () {
    _lottie_light["default"].loadAnimation({
      container: myRef.current,
      renderer: 'svg',
      animationData: _animationData2["default"],
      loop: true
    });
  }, []);

  var getsize = function getsize(initial) {
    return initial ? "".concat(initial, "px") : '90px';
  };

  var style = {
    width: getsize(width),
    height: getsize(height),
    margin: 'auto'
  };
  return (0, _jsxRuntime.jsx)("div", _objectSpread({
    ref: myRef,
    style: style,
    "aria-live": "assertive",
    "aria-label": "Do not refresh the page"
  }, props));
};

var FearlessSpinner = function FearlessSpinner(_ref2) {
  var _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? 'fearless-spinner' : _ref2$name,
      height = _ref2.height,
      width = _ref2.width,
      props = _objectWithoutProperties(_ref2, ["name", "height", "width"]);

  var myRef = (0, _react2.useRef)(null);
  var theme = (0, _react.useTheme)();
  (0, _react2.useEffect)(function () {
    // In case of theme change, destroy any existing animation to avoid duplicating
    _lottie_light["default"].destroy(name);

    _lottie_light["default"].loadAnimation({
      name: name,
      container: myRef.current,
      renderer: 'svg',
      animationData: (0, _animationData["default"])(theme.name === _theme.fearless.name),
      loop: true
    });
  }, [name, theme.name]);

  var getsize = function getsize(initial) {
    return initial ? "".concat(initial, "px") : '80px';
  };

  var style = {
    width: getsize(width),
    height: getsize(height),
    margin: 'auto'
  };
  return (0, _jsxRuntime.jsx)("div", _objectSpread({
    ref: myRef,
    style: style,
    "aria-live": "assertive",
    "aria-label": "Do not refresh the page"
  }, props));
};

var Spinner = function Spinner(_ref3) {
  var props = _extends({}, _ref3);

  var theme = (0, _react.useTheme)();
  return theme.name === 'legacy' ? (0, _jsxRuntime.jsx)(LegacySpinner, _objectSpread({}, props)) : (0, _jsxRuntime.jsx)(FearlessSpinner, _objectSpread({}, props));
};

LegacySpinner.propTypes = {
  height: _propTypes.number,
  width: _propTypes.number
};
LegacySpinner.defaultProps = {
  height: 90,
  width: 90
};
FearlessSpinner.propTypes = {
  height: _propTypes.number,
  width: _propTypes.number
};
FearlessSpinner.defaultProps = {
  height: 80,
  width: 80
};
var _default = Spinner;
exports["default"] = _default;